








import { Component, Vue } from 'vue-property-decorator';
import ToolBox from '@/components/common/ToolBox.vue';
import DrawTypeScope from '@/components/designer/DrawTypeScope.vue';
import { EnumComponentType } from '@/api/com/MetaPattern/MDA/MD/Base/EnumComponentType';
import { BaseComponent } from '@/api/com/MetaPattern/MDA/MD/Base/BaseComponent';

@Component({
  components: {
    ToolBox,
    DrawTypeScope
  }
})
export default class DrawScope extends Vue {
  get curComponentType(): EnumComponentType {
    const element = this.$store.state.ModuleMD.curMDElement;
    if (element instanceof BaseComponent) {
      return (element as BaseComponent).componentType;
    }

    return EnumComponentType.APP;
  }
}
